import { render, staticRenderFns } from "./DeviceGroupBrowser.vue?vue&type=template&id=157a27c2"
import script from "./DeviceGroupBrowser.vue?vue&type=script&lang=ts"
export * from "./DeviceGroupBrowser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports